module.exports = __webpack_public_path__ + "img/backend-development.a2e7203f.png";